import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { api } from '../api';
import { useMe } from '../auth/useMe';
import { visibleMenu } from '../auth/me';
import { TodoCard } from '../todo/TodoCard';
import { TODO_KEY, type TodoList } from '../todo/types';

/** How long the home page waits for "Do zrobienia" before going to the first section (the server gives each source 1,5 s). */
export const HOME_WAIT_MS = 2500;

/**
 * Landing: "Do zrobienia" (F46) when something waits for the user; otherwise, as before, straight to the first section
 * the user may open (or a short explanation without any).
 */
export function HomePage() {
  const { me } = useMe();
  const todo = useQuery({ queryKey: TODO_KEY, enabled: !!me, queryFn: () => api<TodoList>('/api/todo') });
  // review I1: never a blank page — a short "Wczytywanie…", and past the wait straight on as before F46
  const [gaveUp, setGaveUp] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setGaveUp(true), HOME_WAIT_MS);
    return () => clearTimeout(timer);
  }, []);
  if (!me) return null;
  // "Podsumowanie" shows the same things as the empty list: not a place to land on
  const first = visibleMenu(me).find((i) => i.to !== '/podsumowanie');
  if (todo.isLoading && !gaveUp) {
    return (
      <section className="page narrow">
        <p className="muted" role="status">
          Wczytywanie…
        </p>
      </section>
    );
  }
  if (todo.data && todo.data.count > 0) {
    return (
      <section className="page narrow">
        <h1>Cześć, {me.name.split(' ')[0]}</h1>
        <TodoCard todo={todo.data} />
      </section>
    );
  }
  if (first) return <Navigate to={first.to} replace />;
  return (
    <section className="page narrow">
      <h1>Cześć, {me.name.split(' ')[0]}</h1>
      <p className="muted">
        Twoje konto jest aktywne, ale nie ma jeszcze przypisanych uprawnień do żadnej sekcji. Poproś właściciela o ich nadanie.
      </p>
    </section>
  );
}
